import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { Switch as r, FormControlLabel as t, Typography as c } from "@mui/material";
import { StyledRoot as n, StyledSwitchHelperText as d } from "./styles44.mjs";
const p = ({
  label: l,
  helperText: e,
  hasError: a = !1,
  ...i
}) => !l ? /* @__PURE__ */ o(r, { ...i }) : /* @__PURE__ */ s(n, { children: [
  /* @__PURE__ */ o(
    t,
    {
      control: /* @__PURE__ */ o(
        r,
        {
          focusVisibleClassName: ".Mui-focusVisible",
          disableRipple: !1,
          ...i
        }
      ),
      label: /* @__PURE__ */ o(c, { variant: "body1", children: l })
    }
  ),
  e && /* @__PURE__ */ o(
    d,
    {
      $hasError: a,
      $disabled: !!i.disabled,
      children: e
    }
  )
] });
export {
  p as Switch
};
//# sourceMappingURL=index65.mjs.map
